import { render, staticRenderFns } from "./deleteInvoiceApply.vue?vue&type=template&id=0b8d2e06"
import script from "./deleteInvoiceApply.vue?vue&type=script&lang=js"
export * from "./deleteInvoiceApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports